export default {
  name: 'CustomObjectAbout',
};
